export const SAFARI_BROWSER = 'safari';
